module.exports = __webpack_public_path__ + "p-plater.jpg?36f63de6af8548a6d68b007f8b34c008";